import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-simple-tab',
    templateUrl: './simple-tab.component.html',
    styleUrls: ['./simple-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class SimpleTabComponent {
    @Input() public title: string;
    @Input() public active = false;
    @Input() public isValid: boolean;
}
